// MUI's <Select> renders its dropdown list in a Paper that's portaled outside the component
// tree, so it never picks up the dark, per-page `logoColors` sx overrides used everywhere else
// in the admin dashboard - it was falling back to the global light theme's white Paper, giving
// every dropdown a jarring white flash. This one MenuProps object, spread onto every admin
// <Select>, keeps them all visually consistent with the rest of the dark UI.
export const darkSelectMenuProps = (colors) => ({
    PaperProps: {
        sx: {
            backgroundColor: colors.darkBlue,
            border: `1px solid ${colors.lightYellow}40`,
            '& .MuiMenuItem-root': {
                color: colors.brightYellow,
                '&:hover': { backgroundColor: `${colors.lightYellow}20` },
                '&.Mui-selected': {
                    backgroundColor: `${colors.brightYellow}25`,
                    '&:hover': { backgroundColor: `${colors.brightYellow}35` },
                },
            },
        },
    },
});
